export type IconType = 'tuiIcon' | 'lucideIcon' | 'local' | 'remote';
